import React from "react";
import { CTA_TYPE, trackActionEvent } from "../../../utils/Omniture";

const BusTrainPassWidget = () => {
    const textToCopy = "BUSTRN"
    const onClickCb = (e) => {
        { navigator.clipboard.writeText(textToCopy) }
        const eventDetails = {
            cta:{
              "name": "CLICK TO COPY CODE",
              "type": CTA_TYPE.IMAGES,
              "componentName": "BUSPASSWIDGET",
              "destination": "-"
          }
        }
        trackActionEvent("ctaClick",eventDetails);
    }

    return (
        <>
            <div className="whiteCard travelPass">
                <h2>Get a Travel Pass just for ₹99</h2>
                <p className="discountTxt">
                    Avail a discount of upto ₹250 over 5 trips via bus or trains. Get a discount of <span className="discBoldTxt">₹50 on bus </span>and <span className="discBoldTxt">₹25 on trains. </span>
                    Apply the coupon via our offers/ coupon section and use it automatically over next 4 trips.
                </p>
                <button className="copyBtn" onClick={onClickCb}>
                    CLICK TO COPY CODE
                </button>
            </div>
        </>
    );
}

export default BusTrainPassWidget;